import styled from "styled-components";
import { colors } from "styles/colors";

interface ErrorStyle {
  error: boolean;
}

export const MainContainer = styled.div<ErrorStyle>`
  display: flex;
  flex-direction: column;
  border-left: 1px solid
    ${(props) => (props.error ? colors.error : colors.border)};
  border-bottom: 1px solid
    ${(props) => (props.error ? colors.error : colors.border)};
  border-right: 1px solid
    ${(props) => (props.error ? colors.error : colors.border)};
  border-radius: 4px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HeaderBorderBefore = styled.div<ErrorStyle>`
  border-top: 1px solid
    ${(props) => (props.error ? colors.error : colors.border)};
  width: 1em;
  border-top-left-radius: 5px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.25em;
  width: fit-content;
  height: 2em;
  margin: -1em 0.5em 0 0.5em;
  overflow: hidden;
`;

export const HeaderBorderAfter = styled.div<ErrorStyle>`
  border-top: 1px solid
    ${(props) => (props.error ? colors.error : colors.border)};
  width: 1em;
  flex-grow: 2;
  border-top-right-radius: 5px;
`;
